module.exports = __webpack_public_path__ + "img/icon_map_3_5_hg_c.2e53bfc1.png";